// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e2b8f987","455":"3515ea76","977":"bdcc1e88"}[chunkId] + ".chunk.js";
};